import { connect } from 'react-redux';

import {
  applyCouponUserAction,
  setApplyCouponMessage,
} from '../../actions/accountSettingsAction';
import {
  getApplyCouponMessageSelector,
  getCouponUserSelector,
  getUserSubscription,
  loadApplyCouponSelector,
} from '../../components/AccountSettings/AccountSettingsSelectors';
import ApplyCoupon from '../../components/AccountSettings/ApplyCoupon/applyCoponView';
import { getUser } from '../../components/User/userSelectors';

const mapStateToProps = (state) => ({
  user: getUser(state),
  userSubscription: getUserSubscription(state),
  coupon: getCouponUserSelector(state),
  applyCouponMessage: getApplyCouponMessageSelector(state),
  loadApplyCoupon: loadApplyCouponSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  applyCouponUser: (coupon) => dispatch(applyCouponUserAction(coupon)),
  setApplyCouponMessage: (message) => dispatch(setApplyCouponMessage(message)),
});

const ApplyCouponContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ApplyCoupon);

export default ApplyCouponContainer;
